import React from 'react';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FaqContent from '../components/FaqContent';

const Faq = () => {
	return (
		<>
			<Navbar />
			<FaqContent />
			<Footer />
		</>
	);
};

export default Faq;
